module.exports = __webpack_public_path__ + "img/article_ad_banner_01.ad5c73df.png";